export const data = {
  about:
    "I am a Software Developer with over four years of experience in web and mobile application development. I worked in large international teams in the fields of sports streaming services and gambling industry. I am familiar with business processes and goals, always open to learning new technologies and implementing best practices in applications development.",
};
